<template>
  <!-- 忘记密码 -->
<div class="forget">
<el-row>
<!-- pc -->
  <el-col :span="10" :offset="7" v-if="WidthSize > 1000">
<div class="from" >
<span class="title">忘记密码</span>
<!-- 开始 -->
<!--
 <el-row :gutter="20">
   <el-col :span="12" :offset="6"><div class="grid-content bg-purple"></div></el-col>
 </el-row>
 -->
<el-row :gutter="20">
   <el-col :span="18" :offset="1"><div class="grid-content bg-purple">
<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
<el-form-item label="手机号" prop="mobile">
    <el-input  v-model.number="ruleForm.mobile" autocomplete="off" placeholder="请输入手机号" @blur="handch"></el-input>
  </el-form-item>
<el-slider v-model="value1" v-show="OnShow"></el-slider>
<el-form-item label="验证码" prop="sms_code">
        <el-input v-model="ruleForm.sms_code" style="float: left;display: inline-block;width: 50%;" placeholder="请输入验证码"></el-input>
        <el-button @click.prevent="Verifi" type="primary" :disabled="disabled" style="float: left;margin-left: 0.1rem;">{{btnTitle}}</el-button>
</el-form-item>
<!--  <el-form-item label="密码" prop="pass">
    <el-input type="password" v-model="ruleForm.pass" autocomplete="off" placeholder="请输入密码"></el-input>
  </el-form-item>
  <el-form-item label="确认密码" prop="checkPass">
    <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off" placeholder="请再次输入密码"></el-input>
  </el-form-item> -->
  <el-form-item>
    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
    <el-button @click="resetForm('ruleForm')">重置</el-button>
  </el-form-item>
</el-form>
</div>
</el-col>
 </el-row>
<!-- 结束 -->
</div>
</el-col>
<!-- iphone and ipad -->
  <el-col :span="20" :offset="2" v-if="WidthSize <= 1000">
<div class="from" >
<span class="title">忘记密码</span>
<!-- 开始 -->
<!--
 <el-row :gutter="20">
   <el-col :span="12" :offset="6"><div class="grid-content bg-purple"></div></el-col>
 </el-row>
 -->
<el-row :gutter="20">
   <el-col :span="18" :offset="1"><div class="grid-content bg-purple">
<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
<el-form-item label="手机号" prop="mobile">
    <el-input  v-model.number="ruleForm.mobile" autocomplete="off" placeholder="请输入手机号" @blur="handch"></el-input>
  </el-form-item>
<el-slider v-model="value1" v-show="OnShow"></el-slider>
<el-form-item label="验证码" prop="sms_code">
        <el-input v-model="ruleForm.sms_code" style="float: left;display: inline-block;width: 50%;" placeholder="请输入验证码"></el-input>
        <el-button @click.prevent="Verifi" type="primary" :disabled="disabled" style="float: left;margin-left: 0.1rem;">{{btnTitle}}</el-button>
</el-form-item>
<!--  <el-form-item label="密码" prop="pass">
    <el-input type="password" v-model="ruleForm.pass" autocomplete="off" placeholder="请输入密码"></el-input>
  </el-form-item>
  <el-form-item label="确认密码" prop="checkPass">
    <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off" placeholder="请再次输入密码"></el-input>
  </el-form-item> -->
  <el-form-item>
    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
    <el-button @click="resetForm('ruleForm')">重置</el-button>
  </el-form-item>
</el-form>
</div>
</el-col>
 </el-row>
<!-- 结束 -->
</div>
</el-col>

</el-row>
</div>
</template>

<script>
export default {
data () {
var checkAge = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('手机号没有填写'));
        } else {
          if(value != '') {
            var reg=/^1[3456789]\d{9}$/;
            if(!reg.test(value)){
                callback(new Error('请输入有效的手机号码'));
            }
          }
          callback ()
        }
      };
      var validatePass = (rule, value, callback) => {
        if (value === '' && this.resetForm.medule !='') {
          callback(new Error('请查看手机号或密码是否添加'));
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
          WidthSize:1024,
          disabled:false,
          btnTitle:"获取验证码",
          // num:
          value1:0,
          OnShow:false,
          context:'',
        ruleForm: {
          // pass: '',
          // checkPass: '',
          mobile:'',
          sms_code:''
        },
        rules: {
          mobile: [
            { validator: checkAge, trigger: 'blur' }
          ],
          pass: [
            { validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            { validator: validatePass2, trigger: 'blur' }
          ],
          age: [
            { validator: checkAge, trigger: 'blur' }
          ]
        }
      };
// return {
// }
},
created() {
      window.addEventListener('resize', this.handleResize);
      this.handleResizeing()
},
methods:{
// 手机号
handch() {
// console.log("收假后")
var reg=/^1[3456789]\d{9}$/;
if(this.ruleForm.mobile != '' && reg.test(this.ruleForm.mobile)) {
// 手机号是否可以修改
this.$store.dispatch('getMobile',this.ruleForm.mobile).then((res) => {
// console.log(res)
if(res.data.count == 1 ) {
  // alert('允许修改')
this.OnShow = true
}else {
  // alert('你没有注册过')
this.$message('手机号没有进行给注册,你可以注册试试');
this.ruleForm.mobile = ''
// setInterval(() => {

// },2000)
setTimeout(() => {
  this.$router.push('/register')
},2000)
}
})
}else {
return false
}

},
// 获取验证码
      Verifi () {
        const num = this.value1
        const mobile = this.ruleForm.mobile
        // 判断手机号不能为空
        if(mobile == '') {
          this.$message({
                    showClose: true,
                    message: '手机号没有填写',
                    type: 'warning'
                  });
          // return false

        }else {
          // console.log(num)
          if(num == 100) {
            this.show = !this.show;
            this.validateBtn()
            let data ={
              mobile:mobile,
              num:num,
              code:"password"
              // sms_code: this.ruleForm.sms_code
            }
            // 发送填写的手机信息,发送请求
            this.$store.dispatch("getPass", data).then(() => {
              // console.log(res.data.context.mobile)
              // console.log(res)
              // if(res.data.code == "0") {
              //   console.log("我到了")
              // }
                // this.$message({
                //           showClose: true,
                //           message: res.data.errmsg,
                //           type: 'warning'
                //         })
})
          }else {
            this.$message({
                      showClose: true,
                      message: '将验证拉至到100',
                      type: 'warning'
                    });
          }

        }


      },
// 点击验证码按钮，
      validateBtn(){
         //倒计时
         let time = 60;
         let timer = setInterval(() => {
         if(time == 0) {
          clearInterval(timer);
          this.disabled = false;
          this.btnTitle = "获取验证码";
         } else {
          this.btnTitle =time + '秒后重试';
          this.disabled = true;
          time--
         }
        },1000)
      },
  // 适配
  handleResizeing() {
    // console.log(window.outerWidth)
      this.WidthSize = window.outerWidth
      if(this.WidthSize  <= 1100) {
        this.$router.push('/')
        this.$message('请前往电脑端进行修改')
      }
  },
  handleResize(e) {
    this.WidthSize = e.currentTarget.innerWidth
   // console.log(this.WidthSize)
  },
submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            // alert('submit!');
            // console.log(valid)
            let submiData = {
              mobile:this.ruleForm.mobile.toString(),
              num:this.value1.toString(),
              sms_code:this.ruleForm.sms_code
            }
            // console.log(submiData)
             this.$store.dispatch("getpasssword", submiData).then((res) => {
               // console.log(res)
               // console.log(res.data.context.mobile)
               this.context = res.data.context.mobile
               if(res.data.context.mobile) {
                 // console.log("我到了")
                 this.open()
               }else {
                 return false
               }
             })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      open() {
        // console.log(this.context)
              this.$prompt( '至少8-16个字符，至少1个大写字母，1个小写字母和1个数字','请输入密码', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern:  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/,
                inputErrorMessage: '密码格式不正确'
              }).then(({ value }) => {
                // console.log(value)
                let openData = {
                  mobile : this.context.toString(),
                  password: value.toString()
                }
                this.$store.dispatch('putPassword',openData).then((res) => {
                   console.log(res)
                   // this.$refs[formName].resetFields();
                   this.$router.push('/login')
                })
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '取消输入'
                });
              });
            }
}
}
</script>

<style scoped lang="scss">
.forget {
	width: 100%;
	height: 76vh;
	background-color: #fff;
  .from {
    margin-top: 1rem;
    // height: 50vh;
    background-color: #f5f8fa;
    margin-bottom: 1rem;
    border-radius: 0.2rem;
    .title {
      text-align: center;
      display: block;
      width: 100%;
      height: 30px;
      padding: 20px;
      font-size: 20px;
    }
  }
}
</style>
